type RowItemPriceProps = Partial<{
  price: number;
  title: string;
  description: string;
  percentage: string;
  minus: string;
  isSemiBold?: boolean;
}>;

export function RowItemPrice({
  price,
  title,
  description = "",
  percentage = "",
  minus = "",
  isSemiBold = false,
}: RowItemPriceProps) {
  const showPrice = (amount: number | undefined) => {
    return amount !== undefined ? `£${amount.toFixed(2)}` : "N/A";
  };
  return (
    <div key={title} className={` flex justify-between items-start `}>
      <div className="text-dark-text-functional font-body-font text-xs leading-[150%] font-normal">
        <p>{title}</p>
        {description && <p>{description}</p>}
      </div>
      <p
        className={`text-dark-text-functional font-body-font text-xs leading-[150%] ${
          isSemiBold ? "font-semibold" : "font-bold"
        }  text-right whitespace-nowrap`}
      >
        {percentage ? `${price}${percentage}` : `${minus}${showPrice(price)}`}
      </p>
    </div>
  );
}

export function TotalAmountRow({
  price,
  title,
}: {
  price: number | undefined;
  title: string;
}) {
  return (
    <div className={` flex justify-between items-start`}>
      <div className="text-dark-text-functional font-body-font text-xs leading-[150%] font-bold">
        <p>{title}</p>
      </div>
      <p className="text-dark-text-functional font-body-font text-[25px] leading-[115%] font-bold text-right">
        {price ? `£${price.toFixed(2)}` : "N/A"}
      </p>
    </div>
  );
}
